import { Button, Pagination, Row, Col, Checkbox, Spin, message } from "antd";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
import WeaTools from "../../wea-tools";
import WeaDialog from "../../wea-dialog";
import WeaZmage from "../../wea-zmage";
import WeaTab from "../../wea-tab";
import WeaNewScroll from "../../wea-new-scroll";
import WeaTable from "../../wea-table";
import Search from "./Search";
import WeaLocaleProvider from "../../wea-locale-provider";
import constants from "./constants";
import WeaEcodeLogin from "../wea-ecode-login";
import WeaSelect from "../../wea-select";
import WeaFormItem from "../../wea-form-item";
import WeaTablePage from "../../wea-table-page";
import WeaTextarea from "../../wea-textarea";

const getLabel = WeaLocaleProvider.getLabel;
const {
  quickSearchKey,
  getBrowserConditions,
  getFuncListAll,
  filterData
} = constants;
class Main extends React.Component {
  static defaultProps = {
    ecodePrefixCls: "wea-ecode-browser",
    modalStyle: {
      width: 854,
      height: 652
    },
    num: 3,
    rowKey: "id",
    nameKey: "title",
    btnProps: {
      type: "primary"
    },
    otherParams: {}
  };
  constructor(props) {
    super(props);
    const browserConditions = getBrowserConditions(
      {
        propertyList: []
      },
      this.props.demotype,
      this.getLabels(),
      this.getOtherParams()
    );
    this.state = {
      visible: false,
      selectedData: [],
      selectedValues: [],
      datas: [],
      count: 0,
      pageSize: 9,
      pageNum: 1,
      orderType: "all",
      loading: false,
      loadingUpload: false,
      showSearchAd: false,
      propertyList: [],
      browserConditions,
      defaultImg:
        props.demotype === "workflowChart"
          ? window.ecologyContentPath ||
            "" + "/cloudstore/resource/pc/com/images/ecode-wf-empty.png"
          : window.ecologyContentPath ||
            "" + "/cloudstore/resource/pc/com/images/meeting_default.png",
      selectedKey: "case",
      selectedSubKey: "all",
      passCheck: false, //校验token有效期
      visibleForLogin: false,
      visibleOfApply: false,
      loadingApply: false,
      applyType: "temporary",
      applyList: [],
      loadingApplyList: false,
      visibleOfAuthKey: false,
      authKey: ""
    };
  }
  componentDidMount() {
    const { replaceDatas, valueObj } = this.props;
    if (!isEmpty(replaceDatas)) {
      this.reloadDatas(replaceDatas);
    }
    if (!isEmpty(valueObj)) {
      this.reloadDatas(valueObj);
    }
    WeaTools.callApi("/api/ecode/app/authKey", "GET", {}).then(data => {
      if (data.api_status) {
        this.setState({ authKey: data.authKey });
      } else {
        message.error(data.msg);
      }
    });
  }
  componentWillReceiveProps(nextProps) {
    const { replaceDatas: _replaceDatas } = this.props;
    const { replaceDatas } = nextProps;
    if (
      replaceDatas &&
      !isEqual(_replaceDatas, replaceDatas) &&
      !nextProps.replaceNotCtrl
    ) {
      this.reloadDatas(replaceDatas);
    }
    if (nextProps.valueObj) {
      this.reloadDatas(nextProps.valueObj || []);
    }
  }
  getLabels = () => {
    return {
      keyword: getLabel("518762", "案例名称"),
      platform: getLabel("518763", "平台"),
      industry: getLabel("575", "行业"),
      funtions: getLabel("383", "职能")
    };
  };
  getOtherParams = () => {
    return {
      platform: {
        options: [
          { key: "all", showname: getLabel("82857", "全部") },
          { key: "pc", showname: "PC" },
          { key: "mobile", showname: "MOBILE" }
        ]
      }
    };
  };
  reloadDatas = replaceDatas => {
    const { rowKey } = this.props;
    const selectedValues = replaceDatas.map(data => data[rowKey]);
    this.setState({ selectedValues, selectedData: replaceDatas });
  };
  doChange = (ids, names, datas) => {
    const { onChange } = this.props;
    this.setState({ loadingUpload: false });
    typeof onChange === "function" && onChange(ids, names, datas);
    this.onCancel();
  };
  importFormFromCloudStore = (params = {}) => {
    return new Promise(resolve => {
      WeaTools.callApi(
        "/api/workflow/formSetting/list/importFormFromCloudStore",
        "POST",
        params
      ).then(data => {
        resolve(data);
      });
    });
  };
  importModule = (params = {}) => {
    return new Promise(resolve => {
      WeaTools.callApi("/api/ecode/demo/moduleImport", "POST", params).then(
        data => {
          resolve(data);
        }
      );
    });
  };
  downloadMould = (params = {}) => {
    return new Promise(resolve => {
      WeaTools.callApi(
        "/api/doc/console/importmould/downloadMould",
        "POST",
        params
      ).then(data => {
        resolve(data);
      });
    });
  };
  doImport = (ids, names, datas) => {
    const { demotype, otherParams = {} } = this.props;
    this.setState({ loadingUpload: true });
    if (demotype === "workflowChart") {
      this.importFormFromCloudStore({ demotype, ids, ...otherParams }).then(
        data => {
          if (data.importStatus) {
            message.success(getLabel("129463", "导入成功"));
            this.doChange(ids, names, datas);
          } else {
            message.error(data.msg);
            this.setState({ loadingUpload: false });
          }
        }
      );
    } else if (demotype === "portalTheme") {
      this.importModule({ demotype, ids, ...otherParams }).then(data => {
        if (data.api_status) {
          message.success(getLabel("129463", "导入成功"));
          this.doChange(ids, names, datas);
        } else {
          message.error(data.msg);
          this.setState({ loadingUpload: false });
        }
      });
    } else if (
      demotype === "docViewTemplate" ||
      demotype === "docEditTemplate"
    ) {
      this.importModule({ demotype, ids, moduleName: names }).then(data => {
        if (data.api_status) {
          this.downloadMould({
            fileid: data.fileId,
            mouldName: names,
            ...otherParams
          }).then(moduleData => {
            if (moduleData.api_status) {
              message.success(getLabel("129463", "导入成功"));
              this.doChange(ids, names, datas);
            } else {
              message.error(moduleData.msg);
              this.setState({ loadingUpload: false });
            }
          });
        } else {
          message.error(data.msg);
        }
      });
    }
  };
  doImportApp = record => {
    const params = {
      id: record.id,
      importType: "all",
      clone: "n",
      folderId: record.appId,
      typeId: "",
      autoRelease: "y",
      cs_token: WeaTools.ls.getStr("csToken")
    };
    WeaTools.callApi("/api/ecode/demo/import", "POST", params).then(data => {
      if (data.status) {
        message.success(getLabel("129463", "导入成功"));
      } else {
        message.error(data.msg);
      }
    });
  };
  doApply = () => {
    const { selectedData = [], applyType } = this.state;
    const { nameKey, otherParams, demotype } = this.props;
    this.checkToken().then(data => {
      if (data.api_status) {
        this.setState({ loadingApply: true });
        // 处理申请导入
        const params = {
          appId: selectedData.map(da => da.folderId),
          demoId: selectedData.map(da => da.id),
          applyType,
          cs_token: WeaTools.ls.getStr("csToken"),
          demotype,
          ...otherParams
        };
        WeaTools.callApi("/api/ecode/demo/applyForApp", "POST", params).then(
          data => {
            if (data.status) {
              message.success(getLabel("16248", "提交成功"));
              this.setState({ visibleOfApply: false });
            } else {
              message.error(data.msg);
            }
            this.setState({ loadingApply: false });
          }
        );
      } else {
        this.setState({ visibleForLogin: true });
      }
    });
  };
  handleOk = () => {
    const { selectedData, selectedValues, selectedKey } = this.state;
    const { nameKey } = this.props;
    const names = selectedData.map(data => data[nameKey]).join();
    if (selectedKey === "case") {
      this.doImport(selectedValues.join(), names, selectedData);
    } else if (selectedKey === "app") {
      this.setState({ visibleOfApply: true });
    }
  };
  onCancel = () => {
    this.setState({
      visible: false,
      selectedData: [],
      selectedValues: [],
      passCheck: false,
      visibleForLogin: false,
      visibleOfApply: false
    });
    if (this.ecodeBrowserSearch) {
      this.ecodeBrowserSearch.resetFields();
    }
  };
  onBrowerClick = () => {
    this.getPropertyList();
    this.getData();
    this.setState({
      visible: true,
      selectedKey: this.props.demotype === "portalTheme" ? "app" : "case"
    });
  };
  getParams = () => {
    const { pageSize, pageNum, orderType } = this.state;
    const { demotype } = this.props;
    const formParams = this.ecodeBrowserSearch
      ? this.ecodeBrowserSearch.getFieldsValue()
      : {};
    const params = {
      pageSize,
      pageNum,
      ...formParams,
      demotype
    };
    if (orderType !== "all") params["orderType"] = orderType;
    return params;
  };
  getData = () => {
    const { selectedSubKey } = this.state;
    if (selectedSubKey === "all") {
      const params = this.getParams();
      this.setState({ loading: true });
      WeaTools.callApi("/api/ecode/demo/list", "GET", params).then(data => {
        this.setState({
          datas: data.demoList,
          count: data.count,
          loading: false
        });
      });
    } else if (selectedSubKey === "apply") {
      this.getApplyList();
    }
  };
  // 获取行业/职能数据
  getPropertyList = () => {
    const { demotype } = this.props;
    WeaTools.callApi("/api/ecode/demo/propertyList", "GET", {}).then(data => {
      if (data.status) {
        const datas = JSON.parse(data.data).data || [];
        const browserConditions = getBrowserConditions(
          {
            propertyList: datas
          },
          demotype,
          this.getLabels(),
          this.getOtherParams()
        );
        this.setState({
          propertyList: datas,
          browserConditions
        });
      }
    });
  };
  // 获取已申请的订单信息
  getApplyList = () => {
    this.checkToken().then(() => {
      const keyword = this.ecodeBrowserSearch
        ? this.ecodeBrowserSearch.getFieldValue(quickSearchKey)
        : "";
      const csToken = WeaTools.ls.getStr("csToken");
      const param = {
        pageSize: 10,
        pageNum: 1,
        keyword,
        cs_token: csToken
      };
      this.setState({ loadingApplyList: true });
      WeaTools.callApi("/api/ecode/demo/applyList", "GET", param).then(data => {
        if (data.status) {
          let tempData = data.list || [];
          tempData = tempData.map(v => {
            v["randomFieldOp"] =
              v.applyStatus === "successful" ? [true] : [false];
            return v;
          });
          this.setState({ applyList: tempData });
        } else {
          message.error(data.msg);
        }
        this.setState({ loadingApplyList: false });
      });
    });
  };
  onPageChange = (pageNum, pageSize = this.state.pageSize) => {
    this.setState({ pageNum, pageSize }, () => {
      this.getData();
    });
  };
  onCheck = (value, data) => {
    const { rowKey } = this.props;
    let { selectedData, selectedValues } = this.state;
    if (value) {
      selectedValues.push(data[rowKey]);
      selectedData.push(data);
    } else {
      selectedValues = selectedValues.filter(v => v !== data[rowKey]);
      selectedData = selectedData.filter(v => v[rowKey] !== data[rowKey]);
    }
    this.setState({ selectedData, selectedValues });
  };
  getTable = () => {
    const { num, ecodePrefixCls, rowKey } = this.props; // 自定义每行展示数据的个数
    const { datas, selectedValues, defaultImg } = this.state;
    if (datas) {
      return datas.map(data => {
        const checked = selectedValues.indexOf(data[rowKey]) >= 0;
        const img =
          data.imageList && data.imageList.length > 0 ? data.imageList[0] : {};
        return (
          <Col span={24 / num} className={`${ecodePrefixCls}-table-col`}>
            <div
              className={`${ecodePrefixCls}-table-single${
                checked ? "-active" : ""
              }`}
            >
              <div className={`${ecodePrefixCls}-table-single-con`}>
                <div className={`${ecodePrefixCls}-table-single-checkbox`}>
                  <Checkbox
                    checked={checked}
                    onChange={e => this.onCheck(e.target.checked, data)}
                  />
                </div>
                <div className={`${ecodePrefixCls}-table-single-num`}>
                  <span className={`${ecodePrefixCls}-table-single-num-first`}>
                    <i
                      className={`${ecodePrefixCls}-table-single-num-icon icon-coms-Supervise`}
                    />
                    {data.downloadCounts}
                  </span>
                  <span>
                    <i
                      className={`${ecodePrefixCls}-table-single-num-icon icon-coms-download2`}
                    />
                    {data.downloadCounts}
                  </span>
                </div>
                <div className={`${ecodePrefixCls}-table-single-image`}>
                  <WeaZmage
                    src={img.imageLink || img.thumbnailLink || defaultImg}
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                  />
                </div>
                <div className={`${ecodePrefixCls}-table-single-view`}>
                  {data.detailsUrl && (
                    <span onClick={() => window.open(data.detailsUrl)}>
                      {getLabel("22045", "详情")}
                    </span>
                  )}
                  {data.previewUrl && (
                    <span onClick={() => window.open(data.previewUrl)}>
                      {getLabel("221", "预览")}
                    </span>
                  )}
                </div>
              </div>
              <div
                className={`${ecodePrefixCls}-table-single-title text-elli`}
                title={data.title}
              >
                {data.title}
              </div>
            </div>
          </Col>
        );
      });
    }
    return null;
  };
  onTopBtnClick = orderType => {
    this.setState({ orderType }, () => {
      this.getData();
    });
  };
  getTopBtn = () => {
    const topBtn = [
      { key: "all", title: getLabel("503342", "综合"), icon: "" },
      // { key: 'views', title: getLabel('26668','访问量'), icon: '' },
      { key: "downloadCount", title: getLabel("25204", "下载次数"), icon: "" },
      { key: "createTime", title: getLabel("26080", "更新日期"), icon: "" }
    ];
    const { orderType } = this.state;
    return topBtn.map(btn => (
      <Button
        key={btn.key}
        type={orderType === btn.key && "primary"}
        onClick={() => this.onTopBtnClick(btn.key)}
      >
        <span>{btn.title}</span>
        <i className="icon-coms02-Sort" />
      </Button>
    ));
  };
  getTabButtonsAd = () => {
    return [
      <Button type="primary" onClick={this.onSearch}>
        {getLabel(197, "搜索")}
      </Button>,
      <Button type="ghost" onClick={this.onReset}>
        {getLabel(2022, "重置")}
      </Button>,
      <Button type="ghost" onClick={() => this.setShowSearchAd(false)}>
        {getLabel(31129, "取消")}
      </Button>
    ];
  };
  getTabs = () => {
    return [
      { title: getLabel("519104", "案例"), viewcondition: "case" },
      { title: getLabel("25432", "应用"), viewcondition: "app" }
    ];
  };
  onReset = () => {
    if (this.ecodeBrowserSearch) this.ecodeBrowserSearch.resetFields();
    this.getData();
  };
  onSearch = () => {
    this.setShowSearchAd(false);
    this.getData();
  };
  setShowSearchAd = showSearchAd => {
    this.setState({ showSearchAd });
  };
  renderNoData = () => {
    const { ecodePrefixCls } = this.props;
    return (
      <div className={`${ecodePrefixCls}-no-data`}>
        <div className={`${ecodePrefixCls}-no-data-con`}>
          <i className="icon-coms-blank" />
          <div>{getLabel("83553", "暂无数据")}</div>
        </div>
      </div>
    );
  };
  renderList = subTableClass => {
    const { ecodePrefixCls } = this.props;
    const { count, pageSize, pageNum, loading } = this.state;
    return [
      <div className={`${ecodePrefixCls}-btns`} key="WeaEcodeBrowser_Topbtn">
        {this.getTopBtn()}
      </div>,
      <div
        className={`${ecodePrefixCls}-table ${subTableClass}`}
        key="WeaEcodeBrowser_Table"
      >
        <WeaNewScroll height="100%">
          <Spin spinning={loading}>
            <Row>{this.getTable()}</Row>
          </Spin>
        </WeaNewScroll>
      </div>,
      <div
        className={`${ecodePrefixCls}-pagination`}
        key="WeaEcodeBrowser_Pagination"
      >
        <Pagination
          showQuickJumper
          showSizeChanger
          pageSizeOptions={["9", "18", "27", "36"]}
          showTotal={total => getLabel(385617, "共$s条").replace(/\$s/, total)}
          total={count}
          pageSize={pageSize}
          current={pageNum}
          onChange={this.onPageChange}
          onShowSizeChange={this.onPageChange}
        />
      </div>
    ];
  };
  getSubTabs = () => {
    return [
      { title: getLabel("82857", "全部"), viewcondition: "all" },
      { title: getLabel("18659", "已申请"), viewcondition: "apply" }
    ];
  };
  getColumns = () => {
    return [
      {
        title: getLabel("16841", "订单编号"),
        dataIndex: "appId",
        key: "appId",
        display: "true",
        width: "33%",
        render: text => <span title={text}>{text}</span>
      },
      {
        title: getLabel("15451", "表单名称"),
        dataIndex: "appName",
        key: "appName",
        display: "true",
        width: "30%",
        render: text => <span title={text}>{text}</span>
      },
      {
        title: getLabel("390653", "申请时间"),
        dataIndex: "createDate",
        key: "createDate",
        display: "true",
        width: "18%",
        render: (text, record) => `${text} ${record.createTime}`
      },
      {
        title: getLabel("500401", "类型"),
        dataIndex: "applyType",
        key: "applyType",
        display: "true",
        width: "10%",
        render: text =>
          text === "temporary"
            ? getLabel("519105", "临时(7天)")
            : getLabel("19182", "永久")
      },
      {
        title: getLabel("23247", "状态"),
        dataIndex: "applyStatus",
        key: "applyStatus",
        display: "true",
        width: "8%",
        render: text => {
          if (text === "successful") return getLabel("15376", "通过");
          else if (text === "applying") return getLabel("131030", "审核中");
          if (text === "failed") return getLabel("390557", "不通过");
        }
      },
      {
        dataIndex: "randomFieldId",
        dbField: "randomFieldId",
        from: "set",
        title: "randomFieldId"
      }
    ];
  };
  onOperatesClick = record => {
    this.doImportApp(record);
  };
  renderAppList = () => {
    const { ecodePrefixCls } = this.props;
    const { selectedSubKey, applyList, loadingApplyList } = this.state;
    return (
      <div className={`${ecodePrefixCls}-tableSub-con`}>
        <WeaTab
          type="card"
          datas={this.getSubTabs()}
          selectedKey={selectedSubKey}
          keyParam="viewcondition"
          onChange={v => {
            this.setState({ selectedSubKey: v });
            if (v === "apply") this.getApplyList();
          }}
        />
        {selectedSubKey === "all" ? (
          this.renderList(`${ecodePrefixCls}-tableSub`)
        ) : (
          <WeaTablePage
            columns={this.getColumns()}
            datas={applyList}
            loading={loadingApplyList}
            className="wea-new-table"
            operates={[
              {
                index: "0",
                nodeName: "operate",
                text: getLabel(384124, "导入")
              }
            ]}
            onOperatesClick={this.onOperatesClick}
          />
        )}
      </div>
    );
  };
  selectedIndustry = (value, datas) => {
    const funs = value.value ? value.value.split(",") : [];
    if (funs.length > 0) {
      const selectedIndustry = [];
      funs.forEach(index => {
        const re = datas.find(da => da.funcList.find(v => v.key === index));
        if (re && selectedIndustry.indexOf(re.key) < 0) {
          selectedIndustry.push(re.key);
        }
      });
      if (this.ecodeBrowserSearch) {
        const formParams = this.ecodeBrowserSearch
          ? this.ecodeBrowserSearch.getFieldsValue()
          : {};
        this.ecodeBrowserSearch.setFieldsValue({
          ...formParams,
          industry: selectedIndustry.join(),
          funtions: value.value
        });
      }
    }
  };
  changeCondition = (fields, domkey) => {
    const { browserConditions } = this.state;
    let { propertyList } = this.state;
    propertyList = filterData(propertyList);
    const formParams = this.ecodeBrowserSearch
      ? this.ecodeBrowserSearch.getFieldsValue()
      : {};
    if (domkey === "funtions" && !formParams.industry) {
      this.selectedIndustry(fields.funtions, propertyList);
    }
    if ("industry" in fields) {
      let funcOptions = [];
      const industryValue = fields.industry.value;
      propertyList.forEach(pro => {
        if (pro.key === fields.industry.value) {
          funcOptions = pro.funcList.filter(v => v.key !== "" && v.key !== "0"); // 过滤选项：全部
        }
      });
      browserConditions.forEach(con => {
        if (con.domkey.indexOf("funtions") >= 0) {
          con["options"] =
            industryValue && industryValue !== "0"
              ? getFuncListAll(propertyList, industryValue)
              : getFuncListAll(propertyList);
        }
      });
      this.setState({ browserConditions });
    }
  };
  checkToken = () => {
    const csToken = WeaTools.ls.getStr("csToken");
    return new Promise((resolve, reject) => {
      if (!csToken) {
        this.setState({ passCheck: false, visibleForLogin: true });
        reject();
      } else {
        const loadingMessage = message.loading(
          getLabel("518773", "正在检查登录状态"),
          0
        );
        WeaTools.callApi("/api/ecode/demo/checkTokens", "GET", {
          cs_token: csToken
        }).then(data => {
          setTimeout(loadingMessage, 0);
          this.setState({
            passCheck: data.api_status ? true : false,
            visibleForLogin: data.api_status ? false : true
          });
          resolve(data);
        });
      }
    });
  };
  getApplyProps = () => {
    return {
      detailtype: 3,
      domkey: "applyType",
      value: this.state.applyType,
      options: [
        { key: "temporary", showname: getLabel("519105", "临时(7天)") },
        { key: "permanent", showname: getLabel("19182", "永久") }
      ],
      onChange: v => this.setState({ applyType: v })
    };
  };
  getApplyColumns = () => {
    return [
      // { title: '主键', dataIndex: 'folderId', key: 'folderId' },
      { title: getLabel("15451", "表单名称"), dataIndex: "title", key: "title" }
    ];
  };
  onCancelForApply = () =>
    this.setState({ visibleOfApply: false, loadingApply: false });
  render() {
    const {
      ecodePrefixCls,
      modalStyle,
      customized,
      title,
      iconBgcolor,
      icon,
      btnProps
    } = this.props;
    const {
      visible,
      selectedValues,
      count,
      showSearchAd,
      browserConditions,
      loadingUpload,
      selectedKey,
      visibleForLogin,
      loadingApply,
      visibleOfApply,
      selectedData,
      selectedSubKey,
      loadingApplyList,
      authKey,
      visibleOfAuthKey
    } = this.state;
    let dom = (
      <Button {...btnProps} onClick={this.onBrowerClick}>
        {btnProps.title || getLabel("128328", "从云商店导入")}
      </Button>
    );
    if (customized) {
      dom = (
        <div className="cursor-pointer" onClick={this.onBrowerClick}>
          {this.props.children}
        </div>
      );
    }
    const buttons = [
      <Button
        key="submit"
        type="primary"
        onClick={this.handleOk}
        loading={loadingUpload}
        disabled={selectedValues.length == 0}
      >
        {selectedKey === "case"
          ? getLabel(384124, "导入")
          : getLabel("129", "申请")}
        ({selectedValues.length})
      </Button>,
      <Button key="back" type="ghost" onClick={this.onCancel}>
        {getLabel(385567, "取 消")}
      </Button>
    ];
    const buttonsForApply = [
      <Button
        key="submit"
        type="primary"
        onClick={this.doApply}
        loading={loadingApply}
      >
        {getLabel("83446", "确 定")}
      </Button>,
      <Button key="back" type="ghost" onClick={this.onCancelForApply}>
        {getLabel(385567, "取 消")}
      </Button>
    ];
    const buttonsAd = this.getTabButtonsAd();
    const inputValue = this.ecodeBrowserSearch
      ? this.ecodeBrowserSearch.getFieldValue(quickSearchKey)
      : "";
    const tabs = this.getTabs();
    const applyProps = this.getApplyProps();
    return (
      <div className={ecodePrefixCls}>
        {dom}
        <WeaEcodeLogin
          icon={icon}
          iconBgcolor={iconBgcolor}
          visible={visibleForLogin}
          onCancel={() => {
            this.setState({
              visibleForLogin: false,
              visibleOfApply: selectedSubKey === "all"
            });
            if (selectedSubKey === "apply") this.getApplyList();
          }}
        />
        <WeaDialog
          visible={visibleOfApply}
          title={getLabel("129", "申请")}
          icon={icon}
          iconBgcolor={iconBgcolor}
          maskClosable={false}
          style={{ height: 420 }}
          buttons={buttonsForApply}
          onCancel={this.onCancelForApply}
        >
          <div className={`${ecodePrefixCls}-apply`}>
            <WeaFormItem
              label={getLabel("519106", "授权类型")}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <WeaSelect {...applyProps} />
            </WeaFormItem>
          </div>
          <WeaTable
            columns={this.getApplyColumns()}
            dataSource={selectedData}
            scroll={{ y: 250 }}
          />
        </WeaDialog>
        <WeaDialog
          title={getLabel("519546", "授权码")}
          icon={icon}
          iconBgcolor={iconBgcolor}
          maskClosable={false}
          visible={visibleOfAuthKey}
          style={{ width: 520 }}
          moreBtn={{ datas: [] }}
          onCancel={() => this.setState({ visibleOfAuthKey: false })}
        >
          <div className={`${ecodePrefixCls}-authKey`}>
            <WeaTextarea value={authKey} minRows={5} />
          </div>
        </WeaDialog>
        <WeaDialog
          className="wea-browser-modal"
          visible={visible}
          title={title || getLabel("517262", "选中流程表单")}
          icon={icon}
          iconBgcolor={iconBgcolor}
          maskClosable={false}
          style={modalStyle}
          buttons={buttons}
          onCancel={this.onCancel}
        >
          <WeaTab
            datas={tabs}
            buttonsAd={buttonsAd}
            selectedKey={selectedKey}
            buttons={[
              <Button
                type="primary"
                key="authKey"
                onClick={() => this.setState({ visibleOfAuthKey: true })}
              >
                {getLabel("519546", "授权码")}
              </Button>
            ]}
            searchType={
              selectedSubKey !== "apply" ? ["base", "advanced"] : ["base"]
            }
            keyParam="viewcondition"
            searchsBaseValue={inputValue}
            onChange={v => {
              this.setState({
                selectedKey: v,
                loadingUpload: false,
                selectedSubKey: "all"
              });
              this.reloadDatas([]);
            }}
            searchsAd={
              <Search
                ref={el => (this.ecodeBrowserSearch = el)}
                changeCondition={this.changeCondition}
                browserConditions={browserConditions}
              />
            }
            showSearchAd={showSearchAd}
            setShowSearchAd={this.setShowSearchAd}
            onSearchChange={v =>
              this.ecodeBrowserSearch &&
              this.ecodeBrowserSearch.setFieldsValue({
                [`${quickSearchKey}`]: v
              })
            }
            onSearch={this.onSearch}
          />
          {selectedKey === "case"
            ? count > 0
              ? this.renderList()
              : this.renderNoData()
            : count > 0
            ? this.renderAppList()
            : this.renderNoData()}
        </WeaDialog>
      </div>
    );
  }
}
export default Main;



// WEBPACK FOOTER //
// ./ecology9/base/wea-ecode-browser/index.js